import React, { useState } from "react";
import TaskView from "../common/TaskView";
import { AcousticTask, AcousticTaskDefinition } from "../common/models";
import { TextBox } from "../../TextBox";
import { randomUUID } from "../../../utils";
import { translateReactNode } from "../../../../utils/translateReactNode";
import { useTranslation } from "react-i18next";

const TUTORIAL_URLS: Record<string, string> = {
  'en': 'assets/videos/tutorials/Caterpillar_Passage.mp4',
  'es-419': 'assets/videos/tutorials/Caterpillar_Passage-es-419.mp4'
}

const Definition: AcousticTaskDefinition = {
  name: "Caterpillar Passage",
  title: "Caterpillar Passage",
  description: "This is a passage that contains speech sounds in English by sound frequency to test your ability to produce speech sounds.",
  cohort: 'voice',
  type: 'acoustic-task',
  estimatedCompletionTime: '1:50',
  subTaskDefinitions: [{
    name: "Caterpillar Passage",
    title: "",
    instructions: `Please read the following passage out loud in your typical voice.`,
    content: <TextBox text={`Do you like amusement parks? Well, I sure do. To amuse myself, I went twice last spring. My most MEMORABLE moment was riding on the Caterpillar, which is a gigantic rollercoaster high above the ground. When I saw how high the Caterpillar rose into the bright blue sky I knew it was for me. After waiting in line for thirty minutes, I made it to the front where the man measured my height to see if I was tall enough. I gave the man my coins, asked for change, and jumped on the cart. Tick, tick, tick, the Caterpillar climbed slowly up the tracks. It went SO high I could see the parking lot. Boy was I SCARED! I thought to myself, \"There's no turning back now.\" People were so scared they screamed as we swiftly zoomed fast, fast, and faster along the tracks. As quickly as it started, the Caterpillar came to a stop. Unfortunately, it was time to pack the car and drive home. That night I dreamt of the wild ride on the Caterpillar. Taking a trip to the amusement park and riding on the Caterpillar was my MOST memorable moment ever!`} cohort={'voice'}/>,
    profileName: 'speech',
  }]
};
export const CaterpillarPassageDefinition = Definition;

export const CaterpillarPassage =  ({onCompletion}: {onCompletion: () => void}) => {
  const { i18n } = useTranslation();
  const [task, _setTask] = useState<AcousticTask>(() => ({
    ...Definition,
    id: randomUUID(),
    startedAt: new Date().toISOString(),
    completedAt: null,
    status: 'pending',
    subTasks: Definition.subTaskDefinitions.map((definition) => ({
      ...definition,
      id: randomUUID(),
      instructions: translateReactNode(definition.instructions, Definition.cohort),
      title: translateReactNode(definition.title, Definition.cohort) as string,
    })),
    tutorialUrl: TUTORIAL_URLS[i18n.language] || TUTORIAL_URLS['en']
  }));

  const handleOnCompletion = () => {
    console.log("Audio task completed", task.title);
    onCompletion();
  }

  return (
    <div>
      <TaskView
        task={task}
        onCompletion={handleOnCompletion}
        />
    </div>
  );
}

